export enum PerfilEnum {
  Todos = 1,
}
